export class AppSettings {
  public static readonly TIMEOUT = 3000;
  public static readonly APP_VERSION = process.env.VERSION;
  public static readonly IS_DEV = process.env.NODE_ENV === 'development';
}
